import React, { useState, useEffect } from 'react'
import styled from "styled-components"
import media from "styled-media-query"
import { db, storage } from "../../config/firebase"

const TeachersIntro = () => {

   const [teachers, setTeachers] = useState([{}])
   useEffect(() => {
      db.collection("teacher")
         .onSnapshot((querySnapshot) => {
            const teacherList = querySnapshot.docs.map(async doc => {
               const item = doc.data()
               const storageRef = storage.ref()
               const linkSrc = await
               storageRef.child(item.name).getDownloadURL()
               item.link = linkSrc.toString()

               return item
            })
            Promise.all(teacherList).then(setTeachers)
         })
         
      }, [])
      
      const asc = (n, m) => {
         return n.order - m.order
      }
      const renderTeachers = teachers.sort(asc).map((teacher, i) => {

         return (
            <div className="teacher" key={i}>
               <div className="img">
                  <img src={teacher.link} alt="img"/>
               </div>
               <div className="texts">
                  <h4 className="name">{teacher.name} <span>先生</span></h4>
                  <h5 className="sub">担当教科：<span>{teacher.subject}</span></h5>
                  <p className="intro">{teacher.character}</p>
               </div>
            </div>
         )
      })

   return (
      <TeachersIntroStyle>
         <div className="wrap">
            {renderTeachers}
         </div>
      </TeachersIntroStyle>
   )
}

const TeachersIntroStyle = styled.section`
   margin: 60px 0;
   .wrap {
      width: 80%;
      margin: 0 auto;
      ${media.lessThan("600px")`
         width: 95%;
      `}
   }
   .teacher {
      display: flex;
      border-bottom: 0.5px solid #6E6E6E;
      padding: 30px 0;
      &:last-child {
         border: 0;
      }
      .img {
         height: 200px;
         width: 267px;
         overflow: hidden;
         ${media.lessThan("600px")`
            width: 110px;
            height: 90px;
         `}
         img {
            display: block;
            height: 100%;
            margin: 0 auto;
         }
      }
      .texts {
         margin-left: 50px;
         color: #6E6E6E;
         ${media.lessThan("600px")`
            margin-left: 10px;
         `}
         .name {
            margin-top: 10px;
            font-size: 2.8rem;
            font-weight: bold;
            ${media.lessThan("600px")`
               margin-top: 0px;
               font-size: 1.8rem;
            `}
         }
         .sub {
            margin-top: 15px;
            font-size: 2rem;
            ${media.lessThan("600px")`
               font-size: 1.4rem;
               margin-top: 7px;
            `}
            span {
               font-size: 2rem;
               ${media.lessThan("600px")`
                  font-size: 1.4rem;
               `}
            }
         }
         .intro {
            margin-top: 10px;
            font-size: 1.8rem;
         }
      }
   }
`

export default TeachersIntro